import { Component, OnInit, OnDestroy, signal } from '@angular/core'
import { CommonModule } from '@angular/common'
import { PwaService } from '../../../@core/services/pwa/pwa.service'
import { Subscription } from 'rxjs'

@Component({
  selector: 'app-offline-indicator',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      class="fixed left-0 right-0 z-10 m-auto w-fit transform rounded-full bg-red-600 px-4 py-2 text-sm text-white shadow-lg transition-transform duration-300"
      [class.translate-y-4]="!isOnline()"
      [class.-translate-y-10]="isOnline()"
    >
      <div class="flex items-center justify-center space-x-2">
        <svg
          class="h-4 w-4 shrink-0 animate-pulse"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>

        <!-- Versão desktop -->
        <div class="hidden items-center space-x-2 md:flex">
          <span class="font-medium">Sem conexão com a internet</span>
          <span class="text-red-200">•</span>
          <span class="text-xs text-red-200"
            >Algumas funcionalidades podem estar indisponíveis</span
          >
        </div>

        <!-- Versão mobile -->
        <div class="flex items-center md:hidden">
          <span class="text-xs font-medium">Sem conexão com a internet</span>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 9999;
      }
    `
  ]
})
export class OfflineIndicatorComponent implements OnInit, OnDestroy {
  isOnline = signal(navigator.onLine)
  private subscription = new Subscription()

  constructor(private pwaService: PwaService) {}

  ngOnInit() {
    // Monitora mudanças de conexão
    this.subscription.add(this.listenToNetworkChanges())
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }

  private listenToNetworkChanges() {
    const updateOnlineStatus = () => {
      const wasOnline = this.isOnline()
      const isNowOnline = navigator.onLine

      this.isOnline.set(isNowOnline)

      if (wasOnline !== isNowOnline) {
        console.log(
          'Connection status changed:',
          isNowOnline ? 'online' : 'offline'
        )

        // Log adicional para debug do PWA
        if (isNowOnline) {
          console.log('Connection restored. PWA will check for updates.')
        } else {
          console.log('Connection lost. PWA will work offline.')
        }
      }
    }

    window.addEventListener('online', updateOnlineStatus)
    window.addEventListener('offline', updateOnlineStatus)

    return () => {
      window.removeEventListener('online', updateOnlineStatus)
      window.removeEventListener('offline', updateOnlineStatus)
    }
  }
}
